
















import { Component, Vue, Mixins ,Prop} from "vue-property-decorator";
import store from "@/store";
import { Getter, Action } from "vuex-class";

@Component({})
export default class distributeModeExplanation extends Vue {
  @Prop() showDistributeModeModal!: boolean;
  
  @Action("changeShowFooter") changeShowFooter!: Function;

  goBack() {
    this.$emit("closeModal");
    this.changeShowFooter(true)
  }
}
